enum FareClass {
  Monthly = 'Monthly',
  Yearly = 'Yearly',
  GeneralLargeFamily = 'GeneralLargeFamily',
  SpecialLargeFamily = 'SpecialLargeFamily',
  WithDisabilities = 'WithDisabilities',
  Unknown = 'Unknown'
}

enum FareAgeGroup {
  Youth = 'Youth',
  General = 'General',
  Elderly = 'Elderly',
  Unknown = 'Unknown'
}

enum FareRegion {
  A = 'A',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  C1 = 'C1',
  C2 = 'C2',
  E1 = 'E1',
  E2 = 'E2',
  Unknown = 'Unknown'
}

/**
 * The type of a fare, described by three properties which
 * generally affect its pricing: a class, the age group
 * of its owner, and the region where the owner can travel
 * with it.
 */
export type FareType = {
  class: FareClass;
  ageGroup: FareAgeGroup;
  region: FareRegion;
};

const unknownType: FareType = {
  class: FareClass.Unknown,
  ageGroup: FareAgeGroup.Unknown,
  region: FareRegion.Unknown
};

const knownTypes = new Map<string, FareType>([
  [
    '1055',
    {
      class: FareClass.Monthly,
      ageGroup: FareAgeGroup.Youth,
      region: FareRegion.A
    }
  ]
]);

function getFareTypeById(id: string | null): FareType {
  if (id === null) {
    return unknownType;
  }
  return knownTypes.get(id) ?? unknownType;
}

export { FareClass, FareAgeGroup, FareRegion, getFareTypeById };
